module.exports = __webpack_public_path__ + "static/media/HONEY.423e158d.png";